import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[600px] lg:min-h-[800px] flex items-center justify-center text-white overflow-hidden">
      {/* 占位图 */}
      <img 
        src="/placeholder.jpeg" 
        alt="背景占位图" 
        className="absolute inset-0 w-full h-full object-cover z-0"
      />
      
      {/* 视频背景 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
        poster="/placeholder.png"
      >
        <source src="/bg.mp4" type="video/mp4" />
      </video>
      
      {/* 遮罩层，确保文字可读性 */}
      <div className="absolute inset-0 bg-black/10 z-10"></div>
      
      {/* 内容区域 */}
      <div className="container mx-auto px-6 lg:px-8 relative z-20 py-20 lg:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight" style={{ 
            textShadow: '0 4px 20px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3)',
            fontFamily: 'Inter, Noto Sans SC, system-ui, sans-serif'
          }}>
            CLC 营销平台
          </h1>
          <p className="text-xl lg:text-2xl mb-8 text-white/90 leading-relaxed" style={{ 
            textShadow: '0 4px 20px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3)',
            fontFamily: 'Inter, Noto Sans SC, system-ui, sans-serif'
          }}>
          招商提报、供给选品、券补优惠、会场搭建、团队协同，一站式营销解决方案
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/dashboard')}
              className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-colors shadow-lg"
            >
              立即开始
            </button>
            <button 
              onClick={() => navigate('/analytics')}
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white/10 transition-colors"
            >
              了解更多
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

